import { useState, useEffect } from 'react'

import { BREAKPOINTS } from '../utils/mediaQuery'

export const useMobileDetection = (breakpoint = BREAKPOINTS.mobile) => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= breakpoint
    }
    return false
  })

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= breakpoint)
    }

    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [breakpoint])

  return isMobile
}

export default useMobileDetection
